import { cn } from '@/helpers/common';
import NotFound from '@/components/svgs/kg/stub';

const StubKG = ({
  withIcon = true,
  texts,
  elementClassName,
}: {
  withIcon?: boolean;
  elementClassName?: {
    mainClassName?: string;
    mainTextClassName?: string;
    subTextClassName?: string;
  };
  texts: { mainText: string; subText?: string };
}) => {
  return (
    <div className={cn('flex flex-col text-kg-black-pearl', elementClassName?.mainClassName)}>
      {withIcon && <NotFound aria-hidden="true" className="w-30 h-25 shrink-0" />}
      <p
        className={cn(
          'mt-6 max-md:text-xl md:text-3xl font-bold text-kg-black-pearl tracking-tighter',
          elementClassName?.mainTextClassName,
        )}
      >
        {texts.mainText}
      </p>
      {texts.subText && (
        <p className={cn('mt-4 text-kg-mako', elementClassName?.subTextClassName)}>
          {texts.subText}
        </p>
      )}
    </div>
  );
};

export default StubKG;
